import employeeSaga from './sagas/EmployeeSaga';

export default [
    employeeSaga,
];